const AMBULATORY_CODES = [
  '99304',
  '99305',
  '99306',
  '99307',
  '99308',
  '99309',
  '99310',
  '99315',
  '99316',
  '99318',
  '99324',
  '99325',
  '99326',
  '99327',
  '99328',
  '99334',
  '99335',
  '99336',
  '99337'
];

const G_CODES = ['G0432', 'G0438', 'G0439'];

const EM_EXCLUSION_CODES = ['99201', '99202', '99203', '99204', '99205', '99211', '99212', '99213', '99214', '99215'];

const HOSPITALIZATION_REQUIRED_POS_CODE = ['21', '31', '32', '33', '51'];

export { AMBULATORY_CODES, HOSPITALIZATION_REQUIRED_POS_CODE, G_CODES, EM_EXCLUSION_CODES };